import { isEmpty } from 'lodash';
import { MobizSystemRole } from '../other/mobiz-system-role.type';
import { SerializableObject } from './serializable-object';

/** The decoded claims from the accessToken. */
export class TokenClaims extends SerializableObject {
  private readonly ROLE_KEY_PREFIX = 'http://mobiz.is/organization/role/';
  private readonly PERMISSIONS_KEY_PREFIX = 'http://mobiz.is/organization/permissions/';

  public unique_name: string;
  public sub: string;
  public role: MobizSystemRole;
  public user_id: string;
  public lang: string;
  public hasMembership: boolean;
  public avatarUrl: string;
  public apitoken_id: string;
  public iss: string;
  public aud: string;
  public exp: number;
  public nbf: number;

  /**
   * Returns the role for an organization.
   * @param organizationId The organization id.
   *
   * @deprecated Use getPermissions instead.
   */
  public getRole(organizationId: string): string {
    const roleKey = this.ROLE_KEY_PREFIX + organizationId;
    return (this as any)[roleKey];
  }

  /**
   * Returns the list of permissions scoped to the organization.
   * The permission are MobizPermission keys.
   * @param organizationId The organization id.
   */
  public getPermissions(organizationId: string): string[] {
    const key = this.PERMISSIONS_KEY_PREFIX + organizationId;
    const permissionsString: string = (this as any)[key];
    if (isEmpty(permissionsString)) {
      return [];
    }
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return <string[]>JSON.parse(permissionsString);
  }

  public userIsAdmin(): boolean {
    return this.role === 'Administrator';
  }
}
